module.exports = __webpack_public_path__ + "media/components/assets/img/logo/air_france-dbb18094bc03409bebab79868184d6d1.png";